import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import SystemNotification from "../../models/system-notification";

export interface SystemNotificationsState {
  items: SystemNotification[];
}

const initialState: SystemNotificationsState = {
  items: [],
};

export const systemNotificationsSlice = createSlice({
  name: "system-notifications",
  initialState,
  reducers: {
    setSystemNotifications: (
      state,
      action: PayloadAction<SystemNotification[]>
    ) => {
      state.items = action.payload;
    },
    clearSystemNotifications: (state) => {
      state.items = [];
    },
  },
});

export const { setSystemNotifications, clearSystemNotifications } =
  systemNotificationsSlice.actions;

export default systemNotificationsSlice.reducer;
